<template>
	<div class="am-team swiper-container"
		:class="{ 'is-idle': !init }"
	>
		<am-button-icon
			class="am-team__prev"
			name="arrow-left"
		/>
		<am-button-icon
			class="am-team__next"
			name="arrow-right"
		/>

		<div class="am-team__wrapper swiper-wrapper">
			<div
				class="am-team__slide swiper-slide"
				v-for="(slide, index) in value"
				:key="index"
			>
				<div class="am-team__container">
					<div class="am-team__body">
						<am-text class="am-team__title" type="subtitle">
							{{ slide.name }}<br />
							<span>{{ slide.role }}</span>
						</am-text>

						<am-text class="am-team__text">
							{{ slide.text }}
						</am-text>
					</div>

					<div class="am-team__photo" :style="{ backgroundImage: `url(${slide.photo})` }">
					</div>
				</div>
			</div>
		</div>

		<div class="am-team__background" :style="{ backgroundImage: `url(${background})` }" v-if="background">
		</div>

		<nav class="am-team__pagination">
		</nav>
	</div>
</template>

<script>
import Swiper from 'swiper'
import AMButtonIcon from '@/components/molecules/AMButtonIcon'
import AMText from '@/components/atoms/AMText'
import { mapGetters } from 'vuex'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
		'am-button-icon': AMButtonIcon
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		value: {
			type: Array,
			default: () => ([
				{
					name: 'Benedito Abbud',
					role: 'Projeto Paisagistíco',
					text: 'Amet quae earum aliquam sequi lorem labore animi autem! Quibusdam ducimus at sequi sint ab Et inventore fuga cumque ea alias cupiditate, consectetur Dolores ea at non iure illum distinctio?',
					photo: 'https://placeimg.com/640/480/any'
				},
				{
					name: 'Benedito Abbud',
					role: 'Projeto Paisagistíco',
					text: 'Amet quae earum aliquam sequi lorem labore animi autem! Quibusdam ducimus at sequi sint ab Et inventore fuga cumque ea alias cupiditate, consectetur Dolores ea at non iure illum distinctio?',
					photo: 'https://placeimg.com/800/600/any'
				},
				{
					name: 'Benedito Abbud',
					role: 'Projeto Paisagistíco',
					text: 'Amet quae earum aliquam sequi lorem labore animi autem! Quibusdam ducimus at sequi sint ab Et inventore fuga cumque ea alias cupiditate, consectetur Dolores ea at non iure illum distinctio?',
					photo: 'https://placeimg.com/800/600/any'
				}
			])
		},
		background: {
			type: String,
			default: '/images/pattern.jpg'
		}
	},

	computed: {
		...mapGetters({
			viewport: 'viewport/getCurrent'
		})
	},

	watch: {
		init(value) {
			if (value)
				this.start()
		}
	},

	data: () => ({
		swiper: null
	}),

	mounted() {
		if (this.init)
			this.start()

		this.swiper = new Swiper(this.$el, {
			pagination: {
				el: this.$el.querySelector('.am-team__pagination'),
				clickable: true
			},
			navigation: {
				prevEl: this.$el.querySelector('.am-team__prev'),
				nextEl: this.$el.querySelector('.am-team__next'),
			},
			breakpoints: {
				768: {
					slidesPerView: 'auto'
				}
			}
		})
	},

	methods: {
		start() {
			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-team__photo, .am-team__background'), 2, {
				x: this.viewport == 'smartphone' ? '0%' : '30%',
				y: this.viewport == 'smartphone' ? '5%' : '0%',
				opacity: 0,
				ease: Power2.easeOut
			}, .15)

			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-text'), 2, {
				y: '100px',
				opacity: 0,
				ease: Power2.easeOut
			}, .3)
		}
	},

	destroyed() {
		this.swiper.destroy()
	}
}
</script>

<style lang="scss">
.am-team{
	min-height: 400px;
	background: #F8F8F8;
	transition: .3s $easeInOutQuad;
	&__wrapper{
	}
	&__slide{
	}
	&__prev,
	&__next{
		display: none;
	}
	&__title{
		margin-bottom: 24px;
		span{
			opacity: .5;
		}
	}
	&__text{
	}
	&__photo{
		background-position: top center;
		background-size: cover;
	}
	&__pagination{
		width: 100%;
		text-align: center;
		position: absolute;
		bottom: 19px;
		span{
			width: 16px;
			height: 16px;
			border-radius: 16px;
			position: relative;
			background: transparent;
			opacity: 1;
			&:after{
				content: "";
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				border-radius: 8px;
				width: 8px;
				height: 8px;
				background: #F5F5F5;
				z-index: 1;
				transition: .15s $easeInOutQuad;
				transform-origin: 0% 0%;
			}
			&.swiper-pagination-bullet-active{
				&:after{
					background: #D5D3D3;
					opacity: 1;
					transform: scale(2) translate(-50%, -50%);
				}
			}
		}
	}

	&.is-idle{
		opacity: 0;
	}

	@include grid-media($smartphone-grid) {
		padding-bottom: 40px !important;
		box-sizing: border-box;
		&__slide{
			width: 90% !important;
			padding: 36px;
			box-sizing: border-box;
			&:before{
				content: "";
				position: absolute;
				top: 15px;
				left: 15px;
				right: 15px;
				bottom: 15px;
				border-radius: 17px;
				box-shadow: 0 8px 15px rgba(black, .16);
				background: white;
				z-index: -1;
			}
		}
		&__container{
			height: 100%;
			display: flex;
			flex-flow: column;
		}
		&__body{
			flex: 1;
			padding-bottom: 24px;
		}
		&__photo{
			background-position: top center;
			background-size: cover;
			border-radius: 14px;
			max-height: 60%;
			flex: 1;
			&:after{
				content: "";
				display: block;
			}
		}
	}

	@include grid-media($tablet-grid) {
		padding-bottom: 48px;
		box-sizing: border-box;
		&__slide{
			width: 90% !important;
			padding: 36px;
			box-sizing: border-box;
			&:before{
				content: "";
				position: absolute;
				top: 15px;
				left: 15px;
				right: 15px;
				bottom: 15px;
				border-radius: 17px;
				box-shadow: 0 8px 15px rgba(black, .16);
				background: white;
				z-index: -1;
			}
		}
		&__container{
			height: 100%;
			display: flex;
			flex-flow: column;
		}
		&__body{
			flex: 1;
			padding: 24px;
		}
		&__photo{
			background-position: top center;
			background-size: cover;
			border-radius: 14px;
			max-height: 60%;
			flex-shrink: 0;
			&:after{
				content: "";
				display: block;
				padding-top: 70%;
			}
		}
	}

	@include grid-media($desktop-grid) {
		&__container{
			height: 100%;
			display: flex;
			@include outer-container;
		}
		&__title{
			margin-bottom: 40px;
		}
		&__body{
			height: 100%;
			display: flex;
			flex-flow: column;
			justify-content: center;
			@include grid-column(4);
			@include grid-push(1);
		}
		&__photo{
			height: 100%;
			@include grid-column(5);
			@include grid-push(1);
		}
		&__prev,
		&__next{
			display: flex;
			position: absolute;
			transform: translate(0, -50%);
			top: 50%;
			z-index: 20;
		}
		&__prev{
			left: 40px;
		}
		&__next{
			right: 40px;
		}
		&__pagination{
			display: none;
		}
		&__background{
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			width: 30%;
		}
	}
}
</style>
